<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal">×</button>
    <h4 class="modal-title">{{TR "Gerätebericht"}}: {{TR "Abschnitt konfigurieren"}}</h4>
</div>
<div class="modal-body">
    {{ERROR_ROW errors.error}}
    {{#WIZARD wizardContext}}
        {{#if filterConfig.isFilter}}
        {{#WIZARD-TAB (TR 'Filter')}}
            {{{DEVICE-FILTER filterConfig}}}
            <div id="js-category-alert" class="row hidden">
                <div class="col-xs-12">
                    <div class="alert alert-danger m-t-15">
                        {{TR "Sie müssen eine Kategorie auswählen."}}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <div class="alert alert-info">
                        <strong>{{TR "Hinweis"}}</strong>: {{TR "Berichte mit Zeitverläufen als Chart oder Tabelle sind nur für maximal 10 explizit ausgewählte Geräte möglich."}}
                    </div>
                </div>
            </div>
        {{/WIZARD-TAB}}
        {{/if}}
        {{#WIZARD-TAB (TR 'Geräteauswahl')}}
            {{{DEVICE-SELECT filterConfig}}}
             <div class="row">
                <div class="col-xs-12">
                    <div class="alert alert-info">
                        <strong>{{TR "Hinweis"}}</strong>: {{TR "Berichte mit Zeitverläufen als Chart oder Tabelle sind nur für maximal 10 explizit ausgewählte Geräte möglich."}}
                    </div>
                </div>
            </div>
        {{/WIZARD-TAB}}
        {{#WIZARD-TAB (TR 'Inhalt')}}
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-12">
                        <label for="report-part-name" class="control-label">{{TR "Bezeichnung"}}</label>
                        <input
                        class="form-control js-name"
                        type="text"
                        name="name"
                        id="report-part-name"
                        value="{{name}}"
                        maxlength="100"
                        ></input>
                        {{#if errors.name}}
                        <ul class="parsley-errors-list filled" id="js-report-part-name-error">
                            <li class="parsley-required">{{TR "Bezeichnung ungültig."}} {{errors.name}}</li>
                        </ul>
                        {{/if}}
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-12">
                        <label for="report-part-description" class="control-label">{{TR "Beschreibung"}}</label>
                        <textarea
                        class="form-control"
                        name="description"
                        id="report-part-description"
                        placeholder="{{TR "Kurze Beschreibung des Abschnitts"}}"
                        maxlength="4000"
                        rows="6"
                        >{{description}}</textarea>
                        {{#if errors.description}}
                        <ul class="parsley-errors-list filled" id="js-report-part-description-error">
                            <li class="parsley-required">{{TR "Beschreibung ungültig."}} {{errors.description}}</li>
                        </ul>
                        {{/if}}
                    </div>
                </div>
            </div>

            <label for="-" class="control-label">{{TR "Inhalt"}}</label>
            {{#ACCORDION selectedSeriesRow}}
            {{#each series}}
                {{#ACCORDION-TAB name type_icon}}
                <div class="form-group js-series-row" data-idx="{{idx}}">
                <div class="row">
                    <div class="col-xs-11">
                        <div class="row" >
                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-6">
                                <label class="control-label">{{TR "Datenquelle"}}</label>
                                {{#SELECT value}}
                                <select class="selectpicker js-edit-series js-value" data-style="btn-white">
                                    {{#each ../availableValues}}
                                    <option value="{{id}}">{{name}}</option>
                                    {{/each}}
                                </select>
                                {{/SELECT}}
                                {{#if isDuplicate}}
                                    <div class="alert alert-danger m-t-5">
                                        {{TR "Bereits definiert. In einem Abschnitt müssen alle Werte und Aggregationsfunktionen unterschiedlich sein."}}
                                    </div>
                                {{/if}}
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                                <label class="control-label">{{TR "Modus"}}</label>
                                {{#SELECT mode}}
                                <select class="selectpicker js-mode js-edit-series-mode" data-style="btn-white">
                                    {{#each modes}}
                                    <option value="{{id}}" data-icon="{{icon}}" {{#if disabled}}disabled="disabled"{{/if}}>{{name}}</option>
                                    {{/each}}
                                </select>
                                {{/SELECT}}
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3">
                                <label class="control-label">{{TR "Aggregation"}}</label>
                                {{#SELECT aggregation}}
                                <select class="selectpicker js-edit-series js-aggregation {{#unless hasAggregation}}disabled{{/unless}}" data-style="btn-white"
                                    {{#unless hasAggregation}}disabled{{/unless}}
                                    >
                                    {{#unless hasAggregation}}
                                    <option value="-1">--</option>
                                    {{else}}
                                    {{#each ../aggregations}}
                                    <option value="{{id}}">{{name}}</option>
                                    {{/each}}
                                    {{/unless}}
                                </select>
                                {{/SELECT}}
                            </div>
                        </div>
                        <div class="row m-t-5">
                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-6">
                                <label class="control-label">{{TR "Beschriftung"}}</label>
                                <input type="text" class="form-control js-edit-series js-name" placeholder="{{TR "Bezeichnung des Wertes"}}" value="{{name}}" id="js-series-name-{{idx}}" maxlength="40">
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                                <label class="control-label">{{TR "Einheit vorgeben"}}</label>
                                <input type="text" class="form-control js-edit-series js-unit" placeholder="{{TR "Standardeinheit"}}" value="{{unit}}">
                            </div>
                        </div>
                        {{#unless noCustomCond}}
                        <div class="row m-t-5" >
                            <div class="col-xs-12">
                                <div class="checkbox checkbox-primary">
                                <input
                                id="custom-cond-{{idx}}"
                                name="chkCustomCond"
                                type="checkbox"
                                {{#if customCond}}checked="checked"{{/if}}
                                class="js-edit-series-render js-cond-custom"
                                >
                                <label for="custom-cond-{{idx}}" class="control-label">{{TR "Erweiterte Einstellungen anzeigen"}}</label>
                                </div>
                            </div>
                        </div>
                        {{#if customCond}}
                            <div class="row m-t-10" >
                                <div class="col-xs-11 col-xs-offset-1">
                                    <label for="custom-cond-{{idx}}" class="control-label">{{TR "Bedingungen"}}</label>
                                </div>
                            </div>
                            {{#each customConditions}}
                            <div class="row m-t-5 js-cond-row" data-idx="{{idx}}">
                                <div class="col-sm-1 col-sm-offset-1">
                                    <button
                                        class="m-t-5 btn btn-sm js-df-cond-color js-color js-cond-render {{#if ../noColorSelect}}disabled{{/if}}"
                                        style="background-color: {{color}}; color:white"
                                        {{#if ../noColorSelect}}disabled="disabled"{{/if}}
                                    >
                                        <i class="fa fa-paint-brush"></i>
                                    </button>
                                </div>
                                <div class="col-sm-10">
                                    <input type="text" class="m-t-5 form-control js-cond-text input-sm js-text-cond-{{../idx}}-{{idx}}"
                                      placeholder="{{TR 'Bezeichnung'}}" value="{{text}}">
                                </div>
                                <div class="col-sm-4 col-sm-offset-2">
                                    {{#SELECT op}}
                                    <select class="m-t-5 selectpicker js-cond-op js-cond-render {{#if ../noComparison}}disabled{{/if}}" data-style="btn-white btn-sm" {{#if ../noComparison}}disabled="disabled"{{/if}}>
                                        {{#each ../../comparison}}
                                        <option value="{{this}}">{{this}}</option>
                                        {{/each}}
                                    </select>
                                    {{/SELECT}}
                                </div>
                                <div class="col-sm-6 m-t-5">
                                    {{#if op}}
                                    {{{FIELD_VALUE fvid ../value this 'value' ../../fieldValuesEnum}}}
                                    {{else}}
                                    --
                                    {{/if}}
                                </div>
                                <div class="col-sm-6 col-sm-offset-6">
                                    <button class="m-t-5 btn btn-white btn-sm pull-right js-df-cond-delete">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                    <button class="m-t-5 btn btn-white btn-sm pull-right js-df-cond-up {{#if noUp}}disabled{{/if}}">
                                        <i class="fa fa-arrow-up"></i>
                                    </button>
                                    <button class="m-t-5 btn btn-white btn-sm pull-right js-df-cond-down {{#if noDown}}disabled{{/if}}">
                                        <i class="fa fa-arrow-down"></i>
                                    </button>
                                </div>
                            </div>
                            {{/each}}
                            <div class="row m-t-5">
                                <div class="col-xs-11 col-xs-offset-1">
                                    <button class="btn btn-white btn-sm js-add-custom-cond" id="rep-cond-add"><i class="fa fa-plus"></i></button>
                                </div>
                            </div>
                            {{#if deviceColors}}
                            <div class="row m-t-10" >
                                <div class="col-xs-11 col-xs-offset-1">
                                    <label for="custom-cond-{{idx}}" class="control-label">{{TR "Gerätefarben"}}</label>
                                </div>
                            </div>
                            <div class="row m-t-5">
                                <div class="col-xs-11 col-xs-offset-1">
                                {{#EACH-COLS deviceColors 2}}
                                    <button
                                        class="btn btn-sm m-r-10 m-t-5 js-device-color js-color {{#if ../noColorSelect}}disabled{{/if}}"
                                        style="background-color: {{color}}; color: white"
                                        {{#if ../noColorSelect}}disabled="disabled"{{/if}}
                                        data-device-id="{{deviceID}}"
                                    >
                                        <i class="fa fa-paint-brush"></i>
                                    </button>
                                    {{deviceName}}
                                {{/EACH-COLS}}
                                </div>
                            </div>
                            {{/if}}
                        {{/if}}
                        {{/unless}}
                    </div>
                    <div class="col-xs-1">
                        <div class="pull-right">
                            <button class="btn btn-white btn-sm js-series-up {{#if noUp}}disabled{{/if}}">
                                <i class="fa fa-arrow-up"></i>
                            </button>
                            <br>
                            <button class="btn btn-white btn-sm js-series-down  {{#if noDown}}disabled{{/if}}">
                                <i class="fa fa-arrow-down"></i>
                            </button>
                            <br>
                            <button class="btn btn-white btn-sm m-t-5 js-delete-series">
                                <i class="fa fa-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
                </div>
                {{/ACCORDION-TAB}}
            {{/each}}
            {{/ACCORDION}}
            <div class="row m-t-5">
                <div class="col-xs-12">
                    <button class="btn btn-white btn-sm js-add-series {{#if noAdd}}disabled{{/if}}" {{#if noAdd}}disabled="disabled"{{/if}}>
                        <i class="fa fa-plus"></i>
                    </button>
                </div>
            </div>
            {{#if canSort}}
            <div class="form-group">
                <div class="row m-t-15">
                    <div class="col-xs-12 col-sm-6 col-md-9">
                        <label class="control-label">{{TR "Sortierung"}}</label>
                        {{#SELECT sortcol}}
                        <select class="selectpicker js-edit-sorting js-sort-col" data-style="btn-white">
                            <option value="name">{{TR "Name"}}</option>
                            {{#each availableValues}}
                            <option value="{{id}}">{{name}}</option>
                            {{/each}}
                        </select>
                        {{/SELECT}}
                        <div class="checkbox checkbox-primary">
                        <input
                        id="sort-desc"
                        name="chkSortDescIdx"
                        type="checkbox"
                        {{#if sortdesc}}checked="checked"{{/if}}
                        class="js-edit-sorting js-sort-desc"
                        >
                        <label for="sort-desc" class="control-label">{{TR "Absteigend sortieren"}}</label>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                        <label class="control-label">{{TR "Top X"}}</label>
                        <input type="number" class="form-control js-limit"
                          placeholder="{{TR 'Limit'}}" value="{{limit}}" min="0">
                    </div>
                </div>
            </div>
            {{/if}}
        {{/WIZARD-TAB}}
    {{/WIZARD}}
</div>
<div class="modal-footer">
    {{{WIZARD-BUTTONS wizardContext}}}
</div>
